import axios from "axios";
import qs from "qs";
import {
  CreateTemplateRequest,
  GetTemplatesParams,
  PaginatedResponse,
  Template,
  TemplateResult,
  TemplateHelperMetadata,
  UpdateTemplateRequest,
  AuditEntry,
} from "../types";

const BASE = "/notification/api/v1/templates";

/** Lista template — POST /search (era GET /) */
export const getTemplates = async (
    params: GetTemplatesParams,
    templateNames?: string[]
): Promise<PaginatedResponse<Template>> => {
  const body = templateNames && templateNames.length > 0 ? templateNames : [];
  const resp = await axios.post(`${BASE}/search`, body, {
    headers: { "Content-Type": "application/json" },
    params,
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'repeat', skipNulls: true }),
  });
  return resp.data;
};

/** Dettaglio template — GET /{templateName} */
export const getTemplate = async (name: string, bodyType = "html"): Promise<Template> => {
  const resp = await axios.get(`${BASE}/${name}`, { params: { bodytype: bodyType } });
  return resp.data;
};

/** Singola versione — GET /{templateName}/versions/{versionNumber} */
export const getTemplateVersion = async (
    name: string,
    versionNumber: number,
    bodyType = "html"
): Promise<Template> => {
  const resp = await axios.get(`${BASE}/${name}/versions/${versionNumber}`, { params: { bodyType } });
  return resp.data;
};

/** Crea template — POST / */
export const createTemplate = async (template: CreateTemplateRequest): Promise<Template> => {
  const resp = await axios.post(`${BASE}/`, template);
  return resp.data;
};

/** Duplica template — POST /{originalTemplateName}/duplicate/{newTemplateName} */
export const duplicateTemplate = async (
    originalName: string,
    newName: string,
    duplicatedBy: string,
    mode?: string,
    version?: number
): Promise<Template> => {
  const resp = await axios.post(
      `${BASE}/${encodeURIComponent(originalName)}/duplicate/${encodeURIComponent(newName)}`, null,
      {
        params: { duplicatedBy, mode, version },
      }
  );
  return resp.data;
};

/** Aggiorna template — PUT / */
export const updateTemplate = async (
    template: UpdateTemplateRequest,
    createNewVersion = false
): Promise<Template> => {
  const resp = await axios.put(`${BASE}/`, template, {
    params: { createNewVersion },
  });
  return resp.data;
};

/** Attiva versione — PUT /{templateName}/versions/{versionNumber}/activate */
export const activateTemplateVersion = async (
    name: string,
    versionNumber: number,
    updatedBy: string
): Promise<Template> => {
  const resp = await axios.put(
      `${BASE}/${name}/versions/${versionNumber}/activate`,
      null,
      { params: { updatedBy } }
  );
  return resp.data;
};

/** Elimina template — DELETE /{templateName} */
export const deleteTemplate = async (
    name: string,
    deletedBy: string
): Promise<TemplateResult> => {
  const resp = await axios.delete(`${BASE}/${name}`, { params: { deletedBy } });
  return resp.data;
};

/** Elimina multipli — POST /bulk-delete */
export const deleteTemplates = async (
    templateNames: string[],
    deletedBy: string
): Promise<TemplateResult[]> => {
  const resp = await axios.post(`${BASE}/bulk-delete`, templateNames, {
    params: { deletedBy },
  });
  return resp.data;
};

/** Elimina versione — DELETE /{templateName}/versions/{versionNumber} */
export const deleteTemplateVersion = async (
    templateName: string,
    versionNumber: number,
    deletedBy: string
): Promise<TemplateResult> => {
  const resp = await axios.delete(
      `${BASE}/${templateName}/versions/${versionNumber}`,
      { params: { deletedBy } }
  );
  return resp.data;
};

/** Audit log — GET /{templateName}/audit */
export const getAuditLog = async (
    templateName: string,
    page = 0,
    size = 20
): Promise<PaginatedResponse<AuditEntry>> => {
  const resp = await axios.get(`${BASE}/${templateName}/audit`, {
    params: { page, size },
  });
  return resp.data;
};

/** Metadata helper template â€” GET /helpers */
export const getTemplateHelpers = async (): Promise<TemplateHelperMetadata[]> => {
  const resp = await axios.get(`${BASE}/helpers`);
  return resp.data;
};
